import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { Button, Grid, Typography } from '@material-ui/core'

import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import EmployeeInfo from '../../../components/Employees/EmployeeInfo'
import EmployeeCredentials from '../../../components/Employees/EmployeeCredentials'
import {
  getRoles,
  saveNewEmployee,
  fetchEmployeeById,
  updateEmployee,
  deleteEmployee,
} from '../../../actions/employee'
import { deleteEmployeeOnDispatch } from '../../../actions/dispatch'
import { getShopList, getShopTerminals } from '../../../actions/shop'
import { openErrorMessage } from '../../../actions/message'
import { hasAccess } from '../../../utils/api'
import ModalDialog from '../../../components/common/ModalDialog'
import NoteList from '../../../components/Notes/NoteList'
import validateInput from '../../../utils/validations/employee'
import { Appcues } from '../../../utils/constants'
import { canManageEmployee } from '../../../utils/api'
import { getCompanyFeatures, getVehicles } from '../../../actions/company'
import { BiotrackUserModalManager } from './BiotrackUser/BiotrackUserModalManager'
import { getMerchantCredentials, lookupUser } from '../../../api/complianceService'

class AddEmployee extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      employee: {
        firstName: '',
        lastName: '',
        password: '',
        pin: '',
        email: '',
        defaultVehicleId: '',
        driver: false,
        driversLicense: '',
        role: '',
      },
      editMode: true,
      employeeId: '',
      errors: {},
      companyFeatures: {},
      showBiotrackOptionsModal: false,
      isComplianceV2: false,
      complianceId: '',
    }
  }

  async componentDidMount() {
    console.log(this.props.location.pathname, 'pathnames')
    let { session } = this.props.authReducer
    await this.props.dispatch(getRoles())
    await this.props.dispatch(getShopList())
    await this.props.dispatch(getVehicles())
    await this.props.dispatch(
      getShopTerminals(session && session.assignedShop && session.assignedShop.id),
    )
    let isComplianceV2 = false

    try {
      const { id, companyId } = session?.assignedShop || {}
      const merchantCredentials = await getMerchantCredentials(companyId, id)
      const complianceConfigs = merchantCredentials?.data?.attributes?.complianceConfigs
      isComplianceV2 = Array.isArray(complianceConfigs)
        ? complianceConfigs.some((config) => config?.complianceV2 === true)
        : false
      this.setState({ isComplianceV2 })
    } catch (e) {}

    let loc = this.props.location.pathname.split('/')
    if (loc.length > 5) {
      this.getEmployeeById(loc[loc.length - 2], isComplianceV2)
    }
    this.callFromDatabase()
  }

  async callFromDatabase() {
    const companyFeaturesList = await this.props.dispatch(getCompanyFeatures())
    this.setState((_, props) => ({
      companyFeatures: companyFeaturesList,
    }))
  }

  getEmployeeById = (id, isComplianceV2) => {
    let { session } = this.props.authReducer
    const { id: shopId, companyId } = session?.assignedShop || {}
    this.props.dispatch(fetchEmployeeById(id)).then(async (res) => {
      let complianceId = ''
      if (isComplianceV2) {
        try {
          const email = res?.email || ''
          const payload = { data: { attributes: { username: email } } }
          const response = await lookupUser(companyId, shopId, payload)
          if (response?.data?.attributes?.exists) {
            complianceId = response?.data?.attributes?.user?.complianceId
          }
        } catch (e) {
          console.error('Error fetching compliance ID:', e)
        }
      }

      this.setState({
        employee: res,
        employeeId: res.id,
        editMode: false,
        companyId: res.companyId,
        complianceId,
      })
      this.props.dispatch(
        getShopTerminals(session && session.assignedShop && session.assignedShop.id),
      )
    })
  }

  onSave = () => {
    const { employee } = this.state
    if (this.isValid(employee)) {
      Appcues.track('Employee saved')
      this.props.dispatch(saveNewEmployee(employee)).then((res) => {
        this.props.history.push('/settings/manage/employees')
      })
    }
  }

  isValid = (employee) => {
    const { errors, isValid } = validateInput(employee)

    if (!isValid) this.setState({ errors })

    return isValid
  }

  showError = (message) => {
    this.props.dispatch(openErrorMessage(message))
  }

  onChange = (key, value) => {
    const { roles = [] } = this.props.employeeReducer || {}
    const { shopsList = {} } = this.props.shopReducer || {}

    let updatedEmployee = {
      ...this.state.employee,
      [key]: value,
    }

    if (key === 'roleId') {
      const adminOrManagerEmployee =
        roles &&
        roles.find((role) => role.id === value && (role.name == 'Admin' || role.name == 'Manager'))
      updatedEmployee.canApplyCustomDiscount = !!adminOrManagerEmployee
      const isAdmin = roles && roles.find((role) => role.id === value && role.name == 'Admin')
      let shopsId = []
      if (isAdmin) {
        shopsList &&
          shopsList.values.length > 0 &&
          shopsList.values.map((shop) => {
            shopsId.push(shop.id)
          })

        updatedEmployee.shops = shopsId
      }
    }

    this.setState({
      employee: updatedEmployee,
      errors: {},
    })
  }

  toggleEdit = () => {
    this.setState({ editMode: !this.state.editMode })
  }

  closeBiotrackOptionsModal = () => {
    this.setState({ showBiotrackOptionsModal: false })
  }

  onDelete = () => {
    Appcues.track('Deleting Employee')
    this.confirmModal.handleClickOpen()
  }

  onConfirmDelete = () => {
    this.props.dispatch(deleteEmployee(this.state.employeeId)).then((res) => {
      Appcues.track('Employee Deleted')
      this.viewAllEmployees()
    })
    this.props.dispatch(
      deleteEmployeeOnDispatch({
        request: {
          id: this.state.employeeId,
          companyId: this.state.companyId,
        },
        provider: 'wmDispatch',
      }),
    )
  }

  viewAllEmployees = () => {
    this.props.history.push('/settings/manage/employees')
  }

  onUpdate = async () => {
    Appcues.track('Employee Updated')
    if (this.isValid(this.state.employee)) {
      await this.props.dispatch(updateEmployee(this.state.employee))
      this.toggleEdit()
    }
  }

  componentWillUnmount() {
    this.state = {} // eslint-disable-line
  }

  canEditEmployee = (employee) => {
    const { roles = [] } = this.props.employeeReducer || {}
    let isValidRole = false

    //selected employee role
    const selectedRole =
      employee && employee.roleId ? roles.find((role) => role.id === employee.roleId) : ''

    if (selectedRole) {
      isValidRole = canManageEmployee(selectedRole)
    }

    return isValidRole
  }

  render() {
    const { roles = [] } = this.props.employeeReducer || {}
    const { shopsList = {} } = this.props.shopReducer || {}
    const { company, terminals, vehicles } = this.props.companyReducer || {}
    const {
      employee = {},
      editMode = false,
      showBiotrackOptionsModal = false,
      isComplianceV2 = false,
      complianceId,
    } = this.state
    const isCompanyAdmin = employee && employee.email === company.email
    const canEditEmployee = this.canEditEmployee(employee)
    const { availableApps = [] } = this.state.companyFeatures || {}
    const {
      session: {
        employee: { id: userId },
      },
    } = this.props.authReducer
    const isSameUser = userId == employee.id

    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={4} md={4} lg={4}>
            {employee && employee.id ? (
              <h3>
                {employee.firstName} {employee.lastName}
              </h3>
            ) : (
              <h3>Add Employee</h3>
            )}
          </Grid>
          <Grid item xs={12} sm={8} md={8} lg={8} className="role_permissions">
            {hasAccess() ? (
              employee && employee.id ? (
                <div
                  className="pull-right margin-bottom-small"
                  style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}
                >
                  {isComplianceV2 && complianceId !== '' && (
                    <Typography className="margin">{`Compliance ID: ${complianceId}`}</Typography>
                  )}
                  {isComplianceV2 && (
                    <Button
                      className="primary-button override-button-margin"
                      onClick={() => this.setState({ showBiotrackOptionsModal: true })}
                    >
                      Compliance User
                    </Button>
                  )}
                  {editMode ? (
                    <Fragment>
                      <Button className="primary-button margin" onClick={this.onUpdate}>
                        Update
                      </Button>
                      <Button className="danger-button margin" onClick={this.toggleEdit}>
                        Cancel
                      </Button>
                    </Fragment>
                  ) : (
                    <Fragment>
                      {canEditEmployee ? (
                        <Button className="primary-button margin" onClick={this.toggleEdit}>
                          Edit
                        </Button>
                      ) : null}
                      {!editMode && canEditEmployee && !isSameUser ? (
                        <Button className="danger-button margin" onClick={this.onDelete}>
                          Delete
                        </Button>
                      ) : null}
                      <Button className="primary-button margin" onClick={this.viewAllEmployees}>
                        Back
                      </Button>
                    </Fragment>
                  )}
                </div>
              ) : (
                <div className="pull-right margin-bottom-small">
                  <Button className="primary-button margin" onClick={this.onSave}>
                    Save
                  </Button>
                  <Button className="danger-button margin" onClick={this.viewAllEmployees}>
                    Cancel
                  </Button>
                </div>
              )
            ) : (
              <div className="pull-right margin-bottom-small"></div>
            )}
          </Grid>
        </Grid>
        <EmployeeInfo
          data={employee}
          editMode={editMode}
          roles={roles}
          shops={(shopsList && shopsList.values) || []}
          vehicles={vehicles && vehicles.values && vehicles.values.length > 0 && vehicles.values}
          onChange={this.onChange}
          isCompanyAdmin={isCompanyAdmin}
          errors={this.state.errors}
          terminals={terminals.values || []}
          availableApps={availableApps}
          isSameUser={isSameUser}
        />
        <EmployeeCredentials
          data={employee}
          editMode={editMode}
          dbRoles={roles}
          shops={(shopsList && shopsList.values) || []}
          onChange={this.onChange}
          terminals={terminals.values || []}
          errors={this.state.errors}
        />

        <BiotrackUserModalManager
          open={showBiotrackOptionsModal}
          onClose={() => this.closeBiotrackOptionsModal()}
          employee={employee}
          assignedShop={this.props.authReducer.session.assignedShop}
          dispatch={this.props.dispatch}
          roles={roles}
        />

        <NoteList data={employee} editMode={editMode} onChange={this.onChange} />

        <ModalDialog
          title={''}
          ref={(c) => (this.confirmModal = c)}
          onConfirm={this.onConfirmDelete}
          confirmText={'Confirm'}
        >
          <Typography variant="subheading" gutterBottom>
            Are you sure want to delete the employee?
          </Typography>
        </ModalDialog>
      </div>
    )
  }
}

export default connect((state) => ({
  dispatch: state.dispatch,
  employeeReducer: state.employeeReducer,
  companyReducer: state.companyReducer,
  shopReducer: state.shopReducer,
  authReducer: state.authReducer,
}))(ContainerWithTitle(AddEmployee, 'Add/Edit Employee '))



// WEBPACK FOOTER //
// ./src/containers/Settings/Employees/AddEmployee.js